<template>
<div>
  <p style="padding: 5px 0;">
    <Button @click="addRecord" icon="ios-add" type="info" long>添加记录</Button>
  </p>

  <Table stripe :columns="attributes" :data="tableData">
    <template slot-scope="{ row, index }" slot="action">
      <span @click="edit(row, index)" title="修改"><Icon type="ios-create"/></span>
      <span @click="del(row, index)" title="删除" v-if="row.seq"><Icon type="ios-trash" color="red"/></span>
    </template>
  </Table>
  <Modal v-model="showAdd" title="添加记录" :footer-hide="true" width="72" @on-visible-change="onClose">
    <edit-domain v-if="showAdd" ref="createDomain" :seq="Object.keys(items).length" :model="model" :items="items[Object.keys(items).length]" @refresh="refresh"></edit-domain>
  </Modal>

  <Modal v-model="showEdit" title="修改记录" :footer-hide="true" width="72" @on-visible-change="onClose">
    <edit-domain v-if="showEdit" ref="editDomain" :seq="seq" :model="model" :items="items[seq]" @refresh="refresh"></edit-domain>
  </Modal>

</div>
</template>

<script>
import EditDomain from '@/components/subject/EditDomain'
import { DeleteOneOfMuitRecord } from '@/api/subject'

export default {
  name: 'edit-multi-domain',
  data: function () {
    return {
      seq: 1,
      showAdd: false,
      showEdit: false
    }
  },
  computed: {
    attributes: function () {
      return this.getAttributes()
    },
    tableData: function () {
      return this.getTableData()
    }
  },
  props: ['items', 'model'],
  components: {
    'edit-domain': EditDomain
  },
  methods: {
    addRecord: function () {
      this.$nextTick(() => {
        this.seq = this.items.length + 1
        this.showAdd = true
      })
    },
    refresh: function () {
      this.$emit('refresh')
    },
    edit: function (row, index) {
      this.$nextTick(() => {
        this.showEdit = true
        this.seq = index + 1
      })
    },
    del: function (row, index) {
      let model = this.model
      let that = this
      this.$Modal.confirm({
        title: '删除记录',
        content: '删除记录不可逆，数据将无法回复，确认删除？',
        onOk: function () {
          var data = {
            domain: model,
            seq: row.seq
          }
          DeleteOneOfMuitRecord(data).then(async res => {
            that.$emit('refresh')
          })
        },
        onCancel: () => {
          this.$Message.info('取消删除')
        }
      })
    },
    onClose: function (result) {
      if (!result) {
        this.refresh()
      }
    },
    getAttributes: function () {
      let attrs = []
      attrs.push({
        title: '序号',
        sortable: true,
        fixed: 'left',
        key: 'seq',
        width: 80
      })
      let item = this.items['1']
      for (var i = 0; i < item.length; i++) {
        let variable = item[i].var
        let unit = variable.unit ? ('(' + variable.unit + ')') : ''
        let attr = {
          title: variable.label + unit,
          sortable: true,
          key: variable.var.toLowerCase()
        }
        attrs.push(attr)
      }
      let action = {
        title: '',
        fixed: 'right',
        slot: 'action',
        width: 60
      }
      attrs.push(action)
      return attrs
    },
    getTableData: function () {
      var records = []
      for (var m = 1; m < Object.keys(this.items).length; m++) {
        var record = {}
        record['seq'] = m
        for (var i = 0; i < this.items[m].length; i++) {
          var item = this.items[m][i].val
          var val = item.val
          if (this.items[m][i].var.codelist) {
            val = this.items[m][i].var.codes[item.val]
          }
          record[this.items[m][i].var.var.toLowerCase()] = val
        }
        records.push(record)
      }
      return records
    }
  }
}
</script>
